module.exports = {
      id: "default-author-usage",
      viewBox: "0 0 122 120",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#default-author",
      toString: function () {
        return this.url;
      }
    }